/**
 * The ID applied to the AfterShip Ads <script> tag when injected.
 */
export const AFTERSHIP_ADS_SCRIPT_ID = '__aftership-ads-script';

/**
 * The CDN URL for the AfterShip Ads Web SDK.
 *
 * §7 of the integration guide claims this origin alone is enough for a
 * Content-Security-Policy. It is not: `astag.aftership.com` and `apps.rokt.com` were both
 * observed too. `my-account` enforces no CSP today, so nothing breaks — see the README
 * before adding one.
 */
export const AFTERSHIP_ADS_SCRIPT_SRC = 'https://astag.am-static.com/v1.js';

/**
 * How long to wait for `window.Astag` to appear after the script's load event before
 * giving up. The SDK defines its global synchronously on execute, so this only guards
 * against a partially-served or blocked script.
 */
export const AFTERSHIP_ADS_GLOBAL_TIMEOUT_MS = 10_000;

/** Default DOM id given to the ad mount point. */
export const AFTERSHIP_ADS_SLOT_ID = 'aftership-ads-slot';
